import * as DialogPrimitive from '@radix-ui/react-dialog'
import clsx from 'clsx'
import * as React from 'react'

const NavigationMenuSheet = DialogPrimitive.Root

const NavigationMenuSheetTrigger = DialogPrimitive.Trigger

const NavigationMenuSheetClose = DialogPrimitive.Close

const NavigationMenuSheetContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(function SheetContent({className, children, ...props}, ref) {
  return (
    <DialogPrimitive.DialogPortal>
      <DialogPrimitive.Overlay
        forceMount
        className={clsx(
          'fixed inset-0 z-30 bg-neutral-1200/8',
          'data-[state=open]:animate-[fadeIn_150ms]',
          'data-[state=closed]:animate-[fadeOut_150ms]',
        )}
      />
      <DialogPrimitive.Content
        forceMount
        ref={ref}
        className={clsx(
          'fixed z-30',
          'inset-y-0 right-0 h-full w-3/4',
          'data-[state=open]:animate-[slideLeft_150ms_ease-out] data-[state=closed]:animate-[slideRight_100ms_ease-in]',
          'bg-neutral-25',
          'max-w-[450px]',
          'outline-none',
          'shadow-lg',
          'bg-primary-1000',
        )}
        {...props}
      >
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.DialogPortal>
  )
})

export {
  NavigationMenuSheet,
  NavigationMenuSheetClose,
  NavigationMenuSheetContent as NavigationMenuContent,
  NavigationMenuSheetTrigger,
}
